import { clearCookies, clearStorage } from '../../../shared/misc';
import {
  LOGIN_USER,
  LOGOUT_USER,
  SET_IS_PASS_THROUGH_USER,
  UPDATE_LOGIN_INFO_USER
} from '../constants';

export const loginUser = (user) => ({ type: LOGIN_USER, payload: user });

export const logoutUser = () => {
  clearCookies();
  clearStorage();
  return { type: LOGOUT_USER, payload: undefined };
};

export const updateLoginInfoUser = (user) => ({ type: UPDATE_LOGIN_INFO_USER, payload: user });

export const setIsPassThroughUser = (isPassThroughUser) => ({
  type: SET_IS_PASS_THROUGH_USER,
  payload: isPassThroughUser
});
